import React, { useContext } from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import Resume from "./resume1.pdf";

const Services = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "white" : "" }}>My Awesome</span>
        <span>services</span>
        <span
          className="my-services"
          style={{ color: darkMode ? "white" : "" }}
        >
          <br />
          I always enjoy building intractive UI's and increase customer
          satisfaction.
          <br />
          Have strong command on html css and javascript the base of web
          development.
          <br />
          Analyze and optimize the performance in existing front end backend
          systems
          <br />
          Implement and maintian performant and scalable data processing backend
          systems
          <br />
        </span>
        <a href={Resume} download>
          <button className="button s-button">Download CV</button>
        </a>
        <div className="blur s-s-blur2" />
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "10rem" }}
          whileInView={{ left: "2rem", top: "1rem" }}
          transition={transition}
        >
          <Card
            emoji={HeartEmoji}
            heading={"Design"}
            detail={"Html5, Css, tailwind, Bootstrap, "}
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "-14rem", top: "14rem" }}
          whileInView={{ left: "-10rem" }}
          transition={transition}
        >
          <Card
            emoji={Glasses}
            heading={"Frontend"}
            detail={"JavaScript, typescript, React, React native, Nextjs"}
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "10rem" }}
          whileInView={{ left: "8rem", top: "15rem" }}
          transition={transition}
        >
          <Card
            emoji={Humble}
            heading={"Backend"}
            detail={"Node js ,express js, monogodb , mysql, Aws"}
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
